// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import DashboardModal from "../ExternalExams/DashboardModal/DashboardModal";
import ExamInsightsModal from "../ExternalExams/ExamInsightsModal/ExamInsightsModal";
import {
  CloseIcon,
  FemaleIcon,
  MaleIcon,
  NeutroisIcon,
} from "src/assets/icons";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

// Contexts
import { useExternalExamsContext } from "src/contexts/exams/ExternalExamsContext";

// Constants
import { sexTypeEnums } from "src/constants/enums";

const ExamInsights = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);

  const {
    selectedPatient,
    openCompareModal,
    uniqueId,
    formattedPatientName,
    actions: { setOpenCompareModal },
  } = useExternalExamsContext();

  return (
    <DashboardModal
      modalBodySx={{ padding: 0 }}
      headerContent={
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "90%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {selectedPatient?.sex === sexTypeEnums.MALE ? (
                <MaleIcon
                  style={{
                    height: "20px",
                    width: "20px",
                    minHeight: "20px",
                    minWidth: "20px",
                  }}
                />
              ) : selectedPatient?.sex === sexTypeEnums.FEMALE ? (
                <FemaleIcon
                  style={{
                    height: "20px",
                    width: "20px",
                    minHeight: "20px",
                    minWidth: "20px",
                  }}
                />
              ) : (
                <NeutroisIcon
                  style={{
                    height: "20px",
                    width: "20px",
                    minHeight: "20px",
                    minWidth: "20px",
                  }}
                />
              )}
              <Typography
                sx={{
                  maxWidth: "100%",
                  display: "block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {formattedPatientName}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                columnGap: "8px",
              }}
            >
              <Typography fontSize="12px">
                {t("Birthdate")}: {selectedPatient?.dateOfBirth?.slice(0, 10)}
              </Typography>
              <Typography fontSize="12px">
                {t("Healthcare Id")}: {uniqueId}
              </Typography>
            </Box>
          </Box>

          <IconButton
            disableRipple
            disableFocusRipple
            onClick={() => setOpenCompareModal(false)}
            sx={{
              padding: "0px",
              color: onSurface,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      }
      isOpen={openCompareModal}
      onClose={() => setOpenCompareModal(false)}
    >
      <ExamInsightsModal />
    </DashboardModal>
  );
};

export default ExamInsights;
